<template>
    <div class="rounded-lg" style="z-index: 200; min-height: 500px;">
        <v-stepper v-model="step" class="white pa-4">
            <v-stepper-header style="flex-wrap: nowrap;">
                <v-stepper-step :complete="step > 1" step="1">
                    Carga de datos
                </v-stepper-step>
                <v-stepper-step :complete="step > 2" step="2">
                    Verificación de datos
                </v-stepper-step>
                <v-stepper-step step="3">
                    Procesamiento de datos
                </v-stepper-step>
            </v-stepper-header>

            <div style="margin-top: 1rem; display: flex; flex-direction: row; justify-content: flex-end;">
                <v-btn class="btnclean" @click="resetAll" :disabled="loading || selectedFiles.length === 0">
                    <v-icon class="mr-2">mdi-broom</v-icon>Reiniciar
                </v-btn>
            </div>

            <v-stepper-items>
                
                <!-- Step 1: Upload Json -->
                <v-stepper-content step="1">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">                                
                                <v-card-title class="font-weight-bold text-nowrap">Importar comprobante de retención desde archivos JSON</v-card-title>
                                <v-card-actions>
                                    <v-row style="margin-top: 1rem;">
                                        <v-col cols="12" md="6" xs="12">
                                            <div style="margin-bottom: 2rem;">
                                                <input
                                                    id="file-input2"
                                                    style="display: none;"
                                                    type="file"
                                                    webkitdirectory
                                                    directory
                                                    multiple
                                                    @click="$event.target.value=''"
                                                    @change="handleFolderFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input2" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                                                    Elegir directorio completo
                                                </label>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div style="margin-bottom: 2rem;">    
                                                <input
                                                    id="file-input-individual2"
                                                    style="display: none;"
                                                    type="file"
                                                    multiple
                                                    accept=".json"
                                                    @click="$event.target.value=''"
                                                    @change="handleIndividualFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input-individual2" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center; ">
                                                    Elegir varios archivos individualmente
                                                </label>
                                            </div>
                                        </v-col>
                                        
                                        <v-col cols="12">
                                            <div v-if="selectedFilesNames.length > 0" style="margin: 1rem 0;">
                                                <h4>Archivos seleccionados:</h4>
                                                <v-data-table 
                                                    :headers="[{text: '', value: 'name'}]" 
                                                    :items="selectedFilesNames"
                                                    :items-per-page="5"
                                                    :footer-props="{
                                                        showFirstLastPage: false,                                         
                                                        'items-per-page-options': [],
                                                        'items-per-page-text':'Items por pagina:',
                                                    }"
                                                    class="file-table"
                                                >
                                                </v-data-table>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                                <v-card-actions style="padding: 1rem; justify-content: flex-end;">
                                    <v-btn v-if="!dataLoaded" class="btn-import" @click="duplicatedValidation" :disabled="loading">
                                        <v-icon class="mr-2">mdi-folder-upload</v-icon>Cargar archivos y continuar
                                    </v-btn>
                                    <v-btn v-else class="btncontinue" @click="nextStep" :disabled="loading">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                
                <!-- Step 2: Verifying data -->
                <v-stepper-content step="2">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Datos de los archivos cargados</v-card-title>
                                <!-- <v-card-text v-if="errors" style="display: flex; flex-direction: row;">
                                    <v-icon color="red darken-4" style="margin: 10px; font-size: 20px;" >mdi-alert-circle</v-icon>
                                    <p style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        Algunos proveedores no se encuentran registrados, sus productos no serán procesados.
                                    </p>
                                </v-card-text> -->
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-checkbox v-model="selectAll" @click.prevent="switchSelectAll" label="Seleccionar todo"></v-checkbox>
                                    </v-col>
                                </v-row>
                                <CustomCSVPeriod @customCSVPeriod="setCustomCSVPeriod" @year="setCustomCSVPeriodYear" @month="setCustomCSVPeriodMonth" 
                                    :cleanState="cleanState" @resetCleanState="() => cleanState = false" :submitState="submitCustomCSVPeriodState" />
                                <v-data-table 
                                    :headers="headers" 
                                    :items="data"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    :item-class="getSelloRowClass"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.isDuplicated" color="orange darken-2" style="margin: 10px; font-size: 20px;" title="El comprobante ya existe y se actualizará">mdi-pencil</v-icon>
                                        <v-icon v-else-if="item.error" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error.message)">mdi-alert-circle</v-icon>
                                        <v-icon v-else style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                    <template v-slot:item.toEntry="{ item }">
                                        <v-checkbox class="check" v-model="item.toEntry" @click.prevent="switchEntryData(item)"></v-checkbox>
                                        <!-- <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon> -->
                                    </template>
                                    <template v-slot:item.selloRecibido="{ item }">
                                        <div class="sello-recibido-editor">
                                            <v-icon
                                                v-if="!hasSelloRecibido(item)"
                                                color="orange darken-2"
                                                small
                                                title="Falta sello recibido"
                                            >mdi-alert</v-icon>
                                            <v-text-field
                                                v-model="item.selloRecibido"
                                                :readonly="isSelloReadOnly(item)"
                                                dense
                                                outlined
                                                hide-details
                                                label="Sello recibido"
                                                class="sello-recibido-input"
                                            ></v-text-field>
                                            <v-btn
                                                v-if="item.selloRecibidoFromJson"
                                                small
                                                color="primary"
                                                class="sello-recibido-edit-button"
                                                :aria-label="isSelloReadOnly(item) ? 'Editar sello recibido' : 'Bloquear sello recibido'"
                                                @click="toggleSelloEditing(item)"
                                            >
                                                <v-icon left small>{{ isSelloReadOnly(item) ? 'mdi-pencil' : 'mdi-lock' }}</v-icon>
                                                {{ isSelloReadOnly(item) ? 'Editar' : 'Bloquear' }}
                                            </v-btn>
                                        </div>
                                    </template>
                                    <template v-slot:item.dteConsultation="{ item }">
                                        <v-btn icon small @click="openDteConsultation(item)">
                                            <v-icon>mdi-open-in-new</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.delete="{ item }">
                                        <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon>
                                    </template>
                                </v-data-table>
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btnoption" @click="processData">Procesar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
        
                <!-- Step 4: Process Data -->
                <v-stepper-content step="3">
                    <v-row>
                        <v-col cols="12">
                            <v-card v-if="loading" class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Procesando la información importada</v-card-title>
                                <v-card-text class="batch-progress-card">
                                    <div class="batch-progress-heading">
                                        <span>Guardando comprobantes...</span>
                                        <strong>{{ batchProgress.completed }} de {{ batchProgress.total }}</strong>
                                    </div>
                                    <v-progress-linear
                                        :value="batchProgressPercent"
                                        color="primary"
                                        height="18"
                                        rounded
                                    ></v-progress-linear>
                                    <div class="batch-progress-percent">{{ batchProgressPercent }}%</div>
                                    <div class="batch-progress-counters">
                                        <div class="batch-progress-counter batch-progress-success">
                                            <span>Guardados</span>
                                            <strong>{{ batchProgress.processed }}</strong>
                                        </div>
                                        <div class="batch-progress-counter batch-progress-pending">
                                            <span>Pendientes</span>
                                            <strong>{{ pendingBatchCount }}</strong>
                                        </div>
                                        <div class="batch-progress-counter batch-progress-error">
                                            <span>Errores</span>
                                            <strong>{{ batchProgress.failed }}</strong>
                                        </div>
                                        <div class="batch-progress-counter batch-progress-neutral">
                                            <span>No seleccionados</span>
                                            <strong>{{ excludedCount }}</strong>
                                        </div>
                                    </div>
                                    <p class="batch-progress-note">
                                        Los pendientes y no seleccionados no se contabilizan como errores.
                                    </p>
                                </v-card-text>
                            </v-card>
                            <v-card v-else class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Estado del procesamiento de datos</v-card-title>

                                <v-card-text v-if="batchProgress.total || excludedCount" class="batch-progress-card">
                                    <div class="batch-progress-heading">
                                        <span>Resumen del procesamiento</span>
                                        <strong>{{ batchProgress.completed }} de {{ batchProgress.total }} procesados</strong>
                                    </div>
                                    <v-progress-linear
                                        :value="batchProgressPercent"
                                        :color="batchProgress.failed ? 'warning' : 'success'"
                                        height="18"
                                        rounded
                                    ></v-progress-linear>
                                    <div class="batch-progress-percent">{{ batchProgressPercent }}%</div>
                                    <div class="batch-progress-counters">
                                        <div class="batch-progress-counter batch-progress-success">
                                            <span>Guardados</span>
                                            <strong>{{ batchProgress.processed }}</strong>
                                        </div>
                                        <div class="batch-progress-counter batch-progress-pending">
                                            <span>Pendientes</span>
                                            <strong>{{ pendingBatchCount }}</strong>
                                        </div>
                                        <div class="batch-progress-counter batch-progress-error">
                                            <span>Errores</span>
                                            <strong>{{ batchProgress.failed }}</strong>
                                        </div>
                                        <div class="batch-progress-counter batch-progress-neutral">
                                            <span>No seleccionados</span>
                                            <strong>{{ excludedCount }}</strong>
                                        </div>
                                    </div>
                                </v-card-text>

                                <v-card-text v-if="!processError && processed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Se han procesado un total de {{ processed.length }} facturas de comprobante de retención importadas desde los archivos seleccionados.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showProcessed=!showProcessed" style="min-width: 100px;">
                                            {{!showProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <!-- <v-btn class="btnoption" @click="exportToExcel('SUCCESS')" style="background-color: #00a178 !important;">
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn> -->
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table 
                                    v-if="showProcessed"
                                    :headers="processHeaders" 
                                    :items="processed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{}">
                                        <v-icon style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="!processError && notProcessed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        Se encontraron {{ notProcessed.length }} comprobantes con errores durante el guardado.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showNotProcessed=!showNotProcessed" style="min-width: 100px;">
                                            {{!showNotProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showNotProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <!-- <v-btn class="btnoption" @click="exportToExcel('ERROR')" style="background-color: #00a178 !important;">
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn> -->
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table 
                                    v-if="showNotProcessed"
                                    :headers="processHeaders" 
                                    :items="notProcessed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Productos por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.error?.customer" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error.message || 'Ha ocurrido un error al insertar el cliente de esta factura de comprobante de retención.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else-if="item.error?.isDuplicated" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError('Esta factura de comprobante de retención ya se encuentra registrada en la base de datos.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error?.message || 'Ha ocurrido un error al insertar la factura de comprobante de retención de este archivo JSON.')">mdi-alert-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="processError" style="display: flex; flex-direction: row;">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Ha ocurrido un error en el procesamiento, vuelva a intentarlo más tarde. 
                                    </h3> 
                                </v-card-text>
                                
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="resetAll">Volver al inicio</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                    
            </v-stepper-items>
        </v-stepper>
        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        />
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import CustomCSVPeriod from "../../components/Misc/CustomCSVPeriod.vue";
import { findSelloRecibido, parseJsonRelaxedCanonical } from "@/helpers/parseJson";

export default {
    name: "InvoiceImportingWithholdings",
    props: ["win"],
    components: {
        // Block,
        Alerts,
        CustomCSVPeriod
        // AccountingAssign,
        // AccountingItemForm
    },
    data() {
        return {
            step: 1,
            loading: false,
            dataLoaded: false,
            selectedFiles: [],
            selectedFilesNames: [],
            errors: null,
            selectAll: false,
            CustomCSVPeriodFlag: false,
            CustomCSVPeriodYear: null,
            CustomCSVPeriodMonth: null,
            percentageIvaCheck: true,
            percentageIva: 100,
            ClasificationRent: '2',
            cleanState: false,
            submitCustomCSVPeriodState: false,
            headers: [],
            data: [],
            processHeaders: [],
            processError: false,
            processed: [],
            notProcessed: [],
            isProcessing: false,
            batchProgress: {
                total: 0,
                completed: 0,
                processed: 0,
                failed: 0,
                status: 'idle',
            },
            excludedCount: 0,
            showNotProcessed: false,
            showProcessed: false,
            id_business: null,
            business: null,
            id_branch: null,
            id_user: null,
            invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito", "Anulada"],
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
        }
    },
    async mounted() {
        this.headers = [
            {text: '' , value: 'toEntry'},
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Sello recibido' , value: 'selloRecibido'},
            {text: 'Consulta DTE' , value: 'dteConsultation', sortable: false},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'ID Cliente' , value: 'customer'},
            {text: 'NIT Cliente' , value: 'nit'},
            {text: 'NRC Cliente' , value: 'nrc'},
            {text: 'Nombre Cliente' , value: 'nombre'},
            {text: 'Nombre Comercial Cliente' , value: 'nombreComercial'},
            
            // {text: 'ivaRete1' , value: 'ivaRete1'},
            // {text: 'ivaPerci1' , value: 'ivaPerci1'},
            // {text: 'totalIva' , value: 'totalIva'},
            // {text: 'reteRenta' , value: 'reteRenta'},
            // {text: 'descuNoSuj' , value: 'descuNoSuj'},
            // {text: 'descuExenta' , value: 'descuExenta'},
            // {text: 'descuGravada' , value: 'descuGravada'},
            // {text: 'porcentajeDescuento' , value: 'porcentajeDescuento'},
            // {text: 'totalDescu' , value: 'totalDescu'},
            // {text: 'totalNoSuj' , value: 'totalNoSuj'},
            // {text: 'totalExenta' , value: 'totalExenta'},
            // {text: 'totalGravada' , value: 'totalGravada'},
            // {text: 'totalNoGravado' , value: 'totalNoGravado'},
            // {text: 'subTotalVentas' , value: 'subTotalVentas'},

            // {text: 'Total Operación' , value: 'montoTotalOperacion'},
            // {text: 'Total a Pagar' , value: 'totalPagar'},
            {text: 'Total IVA retenido' , value: 'resumenTotalIVAretenido'},
            {text: 'Total IVA retenido Letras' , value: 'resumenTotalIVAretenidoLetras'},
            {text: 'Total Iva' , value: 'resumenTotalIva'},
            {text: 'Total Sujeto Retencion' , value: 'resumenTotalSujetoRetencion'},
            {text: '' , value: 'delete'},
        ];

        this.processHeaders = [
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Sello recibido' , value: 'selloRecibido'},
            {text: 'ID Cliente' , value: 'customer'},
            {text: 'NIT Cliente' , value: 'nit'},
            {text: 'NRC Cliente' , value: 'nrc'},
            {text: 'Nombre Cliente' , value: 'nombre'},
            {text: 'Nombre Comercial Cliente' , value: 'nombreComercial'},
            // {text: 'Sub Total' , value: 'subTotal'},
            // {text: 'Descuento Total' , value: 'totalDescu'},
            // {text: 'Total Operación' , value: 'montoTotalOperacion'},
            // {text: 'Total a Pagar' , value: 'totalPagar'},
            {text: 'Total IVA retenido' , value: 'resumenTotalIVAretenido'},
            {text: 'Total IVA retenido Letras' , value: 'resumenTotalIVAretenidoLetras'},
            {text: 'Total Iva' , value: 'resumenTotalIva'},
            {text: 'Total Sujeto Retencion' , value: 'resumenTotalSujetoRetencion'},
        ];
    },
    watch: {
        selectedFiles: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    this.selectedFilesNames.push({name: item.name});
                }
            }
        },
        data: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    if(item.toEntry == false) {
                        this.selectAll = false;
                    }
                }
            }
        },
    },
    methods: {
        handleFolderFiles(event) {
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.toLowerCase().endsWith('.json'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON en el directorio seleccionado.');
            }
        },
        resetAll() {
            this.step = 1;
            this.loading = false;
            this.dataLoaded = false;
            this.selectAll = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.errors = null;
            this.processError = false;
            this.processed = [];
            this.notProcessed = [];
            this.isProcessing = false;
            this.batchProgress = {
                total: 0,
                completed: 0,
                processed: 0,
                failed: 0,
                status: 'idle',
            };
            this.excludedCount = 0;
            this.showNotProcessed = false;
            this.showProcessed = false;
            this.account = {
                id_account: null
            };
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
            this.cleanState = true;
            this.CustomCSVPeriodFlag = false;
            this.CustomCSVPeriodYear = null;
            this.CustomCSVPeriodMonth = null;
        },
        async duplicatedValidation() {
            this.loading = true;
            let isDuplicatedFiles = false
            let invalidJsonFiles = []
            // Procesar los archivos JSON seleccionados
            for (const file of this.selectedFiles) {
                try {
                    const content = await this.readFile(file);
                    const jsonContent = parseJsonRelaxedCanonical(content);
                    const isInDataFiles = this.dataFiles.some(item => item.identificacion.codigoGeneracion === jsonContent.identificacion.codigoGeneracion);
                    jsonContent['fileName'] = file.name;
                    if (!isInDataFiles) {
                        this.dataFiles.push(jsonContent);
                    } else {
                        isDuplicatedFiles = true
                    }
                } catch (error) {
                    console.error(`Error parsing JSON file ${file.name}:`, error);
                    invalidJsonFiles.push({
                        fileName: file.name,
                        error: error.message
                    });
                }
            }
            
            // Manejar archivos JSON inválidos
            if (invalidJsonFiles.length > 0) {
                const errorDetails = invalidJsonFiles.map(item => `${item.fileName}: ${item.error}`).join('\n');
                this.showAlert("warning", "Error de formato JSON", 
                    `Los siguientes archivos tienen errores de formato JSON y no pueden ser procesados:\n\n${errorDetails}\n\nPor favor, corrija estos archivos antes de continuar.`);
                this.loading = false;
                return;
            }
            
            if (isDuplicatedFiles) {
                this.showAlert("question2", "Advertencia", "Algunos archivos están duplicados por lo que se omitirán. Desea continuar?", "structureValidation");
                this.loading = false;
            } else {
                this.structureValidation();
            }

        },
        structureValidation() {
            const invalidJsonFiles = this.dataFiles.filter(file => !this.jsonValidation(file));
            this.dataFiles = this.dataFiles.filter(file => this.jsonValidation(file));
            const invalidFilesNames = invalidJsonFiles.map(file => file.fileName);
            if (invalidJsonFiles.length >= this.dataFiles.length) {
                this.showAlert("warning", "Advertencia", "Ninguno de los archivos tiene la estructura correcta, por favor revise la estructura de los archivos JSON.");
                this.loading = false;
                return;
            } 
            if (invalidJsonFiles.length > 0) {
                this.showAlert("question2", "Advertencia", `Los archivos ${invalidFilesNames.join(", ")} no tienen la estructura correcta y se omitiran. Desea continuar?`, "handleFilesUpload");
                this.loading = false;
            } else {
                this.handleFilesUpload();
            }
        },
        jsonValidation(json) {
            if (!json) return false;

            // Detectar si es la nueva versión del JSON (DCL - Declaración de Comisiones por Liquidación)
            const isNewVersion = this.isNewVersionJson(json);

            if (isNewVersion) {
                // Validación para la nueva versión
                const newVersionAttributes = [
                    'emisor',
                    'receptor', 
                    'identificacion',
                    'cuerpoDocumento',
                    'extension'
                    // responseMH es opcional en la nueva versión
                ];

                for (const key of newVersionAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal para nueva versión: ${key}`);
                        return false;
                    }
                }
            } else {
                // Validación para la versión original
                const principalAttributes = [
                    'emisor',
                    //'donante',
                    'receptor',
                    'resumen',
                    'identificacion',
                    'cuerpoDocumento'
                ];

                for (const key of principalAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal: ${key}`);
                        return false;
                    }
                }
            }

            return true;
        },
        isNewVersionJson(json) {
            // Detecta si es la nueva versión basándose en:
            // 1. Presencia de 'extension' 
            // 2. tipoDte "09" (DCL)
            // 3. cuerpoDocumento como objeto (no array)
            return json.extension && 
                   json.identificacion?.tipoDte === "09" && 
                   json.cuerpoDocumento && 
                   !Array.isArray(json.cuerpoDocumento);
        },
        async checkDuplicatedEntries(value) {
            return await this.$API.importingWithholdingCertificates.verifyDuplicatedEntries({ generatedCodes: value })
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    console.log(error)
                    throw error;
                });
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            const newDate = new Date(`${month}/${day}/${year}`)
            return this.moment(newDate).format('DD/MM/YYYY');
        },
        async getCustomersByNITAndNCR(emisor) {
            return await this.$API.importingWithholdingCertificates.getCustomersByNITAndNCR(emisor)
                .then((res) => {
                    return res
                })
                .catch((error) => {
                    console.log(error);
                    //throw new Error();
                });
        },
        async getCustomersByNITAndNCRBatch(emitters) {
            return await this.$API.importingWithholdingCertificates.getCustomersByNITAndNCRBatch(emitters)
                .catch((error) => {
                    console.log(error);
                    return null;
                });
        },
        normalizeCustomerDocument(value) {
            return String(value || "").replace(/-/g, "").trim();
        },
        getCustomerLookupKey(emisor = {}) {
            return `${this.normalizeCustomerDocument(emisor.nit)}|${this.normalizeCustomerDocument(emisor.nrc)}`;
        },
        async handleFilesUpload() {
            if (!this.selectedFiles.length) {
                this.showAlert("warning", "Advertencia", "Debe seleccionar los archivos a cargar.");
                return;
            }
            this.loading = true;
            try {
                const generatedCodes = this.dataFiles.map(item => item.identificacion.codigoGeneracion);
                const emitters = this.dataFiles.map(item => item.emisor || {});
                const [checkDuplicatedResponse, customerMatches] = await Promise.all([
                    this.checkDuplicatedEntries(generatedCodes),
                    this.getCustomersByNITAndNCRBatch(emitters),
                ]);
                const duplicatedCodes = checkDuplicatedResponse || [];
                const customersByEmitter = new Map(
                    (customerMatches || []).map(match => [match.key, match.customer])
                );

                for (const item of this.dataFiles) {
                    this.currentJson = item.identificacion.codigoGeneracion;                    
                    item.toEntry = true;
                    
                    const customer = customersByEmitter.get(this.getCustomerLookupKey(item.emisor));
                    // console.log('customer', customer);
                    if(!customer){
                        const fileName = this.dataFiles.find(item => item.identificacion.codigoGeneracion.includes(this.currentJson));
                        // console.log('this.dataFiles', this.dataFiles);
                        // console.log('fileName', fileName);
                        if(fileName && fileName.fileName) {
                            this.showAlert("warning", "Advertencia", `Ha ocurrido un error al cargar el archivo ${fileName.fileName}, No encontramos el cliente al que corresponda este comprobante, por favor verifique el documento.`);
                        }
                        this.loading = false;
                        return;
                    } else {
                        item.customer = customer;
                    }

                    if(duplicatedCodes.includes(item.identificacion.codigoGeneracion)) {
                        item.isDuplicated = true;
                    }

                    item.toEntry = true;
                    item.selloRecibido = findSelloRecibido(item) || null;
                    item.selloRecibidoFromJson = Boolean(item.selloRecibido);
                    item.selloRecibidoEditing = !this.hasSelloRecibido(item);

                    const tipoDte = String(item.identificacion?.tipoDte || "")
                        .trim()
                        .padStart(2, "0");
                    const invoiceTypeByDte = {
                        "01": "FCF",
                        "03": "CCF",
                        "05": "NC",
                        "07": "CR",
                        "09": "DCL",
                        "11": "FEX",
                        "14": "FNS",
                    };
                    item.invoiceType = invoiceTypeByDte[tipoDte] || tipoDte;

                    let tributos = {
                        iva: 0,
                    };

                    // Detectar si es la nueva versión
                    const isNewVersionFormat = this.isNewVersionJson(item);

                    if (!isNewVersionFormat && item.resumen && item.resumen.tributos && item.resumen.tributos.length) {
                        // Versión original - procesar tributos desde resumen
                        let index = 11;
                        for (const el of item.resumen.tributos) {
                            if(el.codigo == '20' || el.descripcion.includes('IVA')){
                                tributos.iva = el.valor;
                                if((this.headers.some(i => i.value == 'iva')) !== true) {
                                    this.headers.splice(index, 0, {text: 'IVA' , value: 'iva'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'D1' || el.descripcion.includes('FOVIAL')){
                                tributos.fovial = el.valor;
                                if((this.headers.some(i => i.value == 'fovial')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Fovial' , value: 'fovial'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'C8' || el.descripcion.includes('COTRANS')){
                                tributos.cotrans = el.valor;
                                if((this.headers.some(i => i.value == 'cotrans')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Cotrans' , value: 'cotrans'});
                                    index += 1;
                                }
                            }
                            else {
                                tributos[el.descripcion] = el.valor;
                                if((this.headers.some(i => i.value == el.descripcion)) !== true) {
                                    this.headers.splice(index, 0, {text: el.descripcion , value: el.descripcion});
                                    index += 1;
                                }
                            }
                        }
                    } else if (isNewVersionFormat && item.cuerpoDocumento) {
                        // Nueva versión - extraer IVA desde cuerpoDocumento
                        tributos.iva = item.cuerpoDocumento.iva || 0;
                        if(tributos.iva > 0 && (this.headers.some(i => i.value == 'iva')) !== true) {
                            this.headers.splice(11, 0, {text: 'IVA' , value: 'iva'});
                        }
                    }

                    if(item.invoiceType == "FEX" && !isNewVersionFormat && item.resumen) {
                        item.flete = item.resumen.flete;       
                        item.seguro = item.resumen.seguro;       
                    }

                    let rowData;
                    
                    if (isNewVersionFormat) {
                        // Nueva versión - usar datos de cuerpoDocumento
                        rowData = {
                            ...item,
                            ivaRete1: 0, // No esta en la version nueva creada para mantener el formato original
                            ivaPerci1: item.cuerpoDocumento.ivaPercibido || 0,
                            totalIva: item.cuerpoDocumento.iva || 0,
                            reteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            descuExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuGravada: 0, // No esta en la version nueva creada para mantener el formato original
                            porcentajeDescuento: 0, // No esta en la version nueva creada para mantener el formato original
                            totalDescu: 0, // No esta en la version nueva creada para mantener el formato original
                            totalNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            totalExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            totalGravada: item.cuerpoDocumento.valorOperaciones || 0,
                            totalNoGravado: 0, // No esta en la version nueva creada para mantener el formato original
                            subTotalVentas: item.cuerpoDocumento.subTotal || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            customer: item.customer ? item.customer.ID_Customer : null,
                            nit: item.emisor.nit,
                            nrc: item.emisor.nrc,
                            nombre: item.emisor.nombre,
                            nombreComercial: item.emisor.nombreComercial,
                            subTotal: item.cuerpoDocumento.subTotal || 0,
                            montoTotalOperacion: item.cuerpoDocumento.valorOperaciones || 0,
                            totalPagar: item.cuerpoDocumento.liquidoApagar || 0,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            isDuplicated: item.isDuplicated === true,
                            ItemDeclarationType: 2,
                            // Campos específicos de la nueva versión
                            comision: item.cuerpoDocumento.comision || 0,
                            ivaComision: item.cuerpoDocumento.ivaComision || 0,
                            montoSujetoPercepcion: item.cuerpoDocumento.montoSujetoPercepcion || 0,
                            montoSinPercepcion: item.cuerpoDocumento.montoSinPercepcion || 0,
                            empleadoEntrega: item.extension ? item.extension.nombEntrega : null,
                            codigoEmpleado: item.extension ? item.extension.codEmpleado : null,
                            selloRecibido: item.selloRecibido || null,
                        };
                    } else {
                        // Versión original
                        const totalPagar = item.resumen?.totalPagar || item.resumen?.montoTotalOperacion || 0;
                        rowData = {
                            ...item,
                            ivaRete1: item.resumen?.ivaRete1 || 0,
                            ivaPerci1: item.resumen?.ivaPerci1 || 0,
                            totalIva: item.resumen?.totalIva || 0,
                            reteRenta: item.resumen?.reteRenta || 0,
                            descuNoSuj: item.resumen?.descuNoSuj || 0,
                            descuExenta: item.resumen?.descuExenta || 0,
                            descuGravada: item.resumen?.descuGravada || 0,
                            porcentajeDescuento: item.resumen?.porcentajeDescuento || 0,
                            totalDescu: item.resumen?.totalDescu || 0,
                            totalNoSuj: item.resumen?.totalNoSuj || 0,
                            totalExenta: item.resumen?.totalExenta || 0,
                            totalGravada: item.resumen?.totalGravada || 0,
                            totalNoGravado: item.resumen?.totalNoGravado || 0,
                            subTotalVentas: item.resumen?.subTotalVentas || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            customer: item.customer ? item.customer.ID_Customer : null,
                            nit: item.emisor.nit,
                            nrc: item.emisor.nrc,
                            nombre: item.emisor.nombre,
                            nombreComercial: item.emisor.nombreComercial,
                            subTotal: item.resumen?.subTotal || 0,
                            montoTotalOperacion: item.resumen?.montoTotalOperacion || 0,
                            totalPagar: totalPagar,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            isDuplicated: item.isDuplicated === true,
                            ItemDeclarationType: 2,
                            selloRecibido: item.selloRecibido || null,
                        };
                    }
                    
                    for (const prop in tributos) {
                        rowData = {
                            ...rowData,
                            [prop]: tributos[prop]
                        }
                    }

                    rowData = {
                        ...rowData,
                        resumenTotalIVAretenido: item.resumen.totalIVAretenido,
                        resumenTotalIVAretenidoLetras: item.resumen.totalIVAretenidoLetras,
                        resumenTotalIva: item.resumen.totalIva,
                        resumenTotalSujetoRetencion: item.resumen.totalSujetoRetencion,
                    }
                    

                    this.data.push(rowData);
                }
                this.sortDataByMissingSello();
                setTimeout(() => {
                    this.loading = false;
                    this.dataLoaded = true;
                    this.currentJson = null; 
                    //console.log(this.data);          
                    this.showAlert("success", "Exito", "Los archivos seleccionados fueron cargados correctamente.", "continueStep");
                }, 1000);
            } 
            catch (error) {                
                console.log(error.message);
                // console.log('this.selectedFilesNames', this.selectedFilesNames);
                // console.log('this.currentJson', this.currentJson);
                // console.log('this.dataFiles', this.dataFiles);
                const fileName = this.dataFiles.find(item => item.identificacion.codigoGeneracion.includes(this.currentJson));
                this.loading = false;
                if(fileName && fileName.fileName) {
                    this.showAlert("warning", "Advertencia", `Ha ocurrido un error al cargar el archivo ${fileName.fileName}, revise la estructura del JSON.`);
                }
                else {
                    this.showAlert("warning", "Advertencia", "Ha ocurrido un error al cargar los archivos, vuelva a intentarlo más tarde.");
                }
                this.currentJson = null; 
            }
        },
        readFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => resolve(event.target.result);
                reader.onerror = (error) => reject(error);
                reader.readAsText(file);
            });
        },
        prevStep() {
            this.step--;
        },
        nextStep() {
            if(this.step === 1) {
                if(this.selectedFiles.length && !this.dataLoaded) {
                    this.showAlert("warning", "Advertencia", "Antes de continuar debe cargar los archivos seleccionados.");
                    return;
                }
            }
            if(this.step == 2) {
                let errors = 0;

                if( this.CustomCSVPeriodFlag ) {
                    this.submitCustomCSVPeriodState = true;
                    !this.CustomCSVPeriodMonth && ( errors += 1 );
                    !this.CustomCSVPeriodYear && ( errors += 1 );
                }

                if (errors > 0) {
                    this.showAlert(
                        "warning",
                        "Advertencia",
                        "Debe llenar todos los campos obligatorios"
                    );
                    return;
                }
            }
            this.step++;
        },
        createImportBatchId() {
            return `withholding-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
        },
        updateBatchProgress(response) {
            if (!response) return;

            this.batchProgress = {
                total: Number(response.total) || 0,
                completed: Number(response.completed) || 0,
                processed: Number(response.processed) || 0,
                failed: Number(response.failed) || 0,
                status: response.status || 'processing',
            };
        },
        async waitForImportBatch(batchId) {
            const maxAttempts = 600;

            for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
                const response = await this.$API.importingWithholdingCertificates.getImportingWithholdingCertificatesBatchStatus(batchId);
                this.updateBatchProgress(response);
                if (response.status === 'completed' || response.status === 'failed') {
                    return response;
                }

                await new Promise(resolve => setTimeout(resolve, 1000));
            }

            throw new Error('El procesamiento del lote excedió el tiempo máximo de espera. Consulte el historial antes de volver a enviarlo.');
        },
        validateSelloRecibido(itemsToProcess) {
            const itemsWithoutSello = itemsToProcess.filter(item => !this.hasSelloRecibido(item));

            if (!itemsWithoutSello.length) return true;

            itemsWithoutSello.forEach(item => {
                this.$set(item, 'selloRecibidoEditing', true);
            });

            this.showAlert(
                'warning',
                'Sello de recibido requerido',
                `Debe ingresar el sello de recibido en ${itemsWithoutSello.length} comprobante${itemsWithoutSello.length === 1 ? '' : 's'} antes de procesar.`
            );
            return false;
        },
        async processData() {
            if (this.isProcessing) return;

            const itemsToProcess = this.data.filter(item => item.toEntry === true && !item.error?.providerError);
            if (!itemsToProcess.length) {
                this.showAlert('warning', 'Comprobantes de retención', 'No hay comprobantes seleccionados para procesar.');
                return;
            }
            if (!this.validateSelloRecibido(itemsToProcess)) return;

            this.isProcessing = true;
            this.loading = true;
            this.nextStep();
            try {
                this.processed = [];
                this.notProcessed = [];
                this.processError = false;
                this.excludedCount = this.data.length - itemsToProcess.length;
                this.batchProgress = {
                    total: itemsToProcess.length,
                    completed: 0,
                    processed: 0,
                    failed: 0,
                    status: 'processing',
                };

                for (const item of itemsToProcess) {
                    item.CustomCSVPeriodFlag = this.CustomCSVPeriodFlag;
                    item.CustomCSVPeriodYear = this.CustomCSVPeriodYear;
                    item.CustomCSVPeriodMonth = this.CustomCSVPeriodMonth;
                }

                const batchId = this.createImportBatchId();
                let batchResponse;
                try {
                    batchResponse = await this.$API.importingWithholdingCertificates.importingWithholdingCertificatesBatch({
                        batchId,
                        entries: itemsToProcess,
                    });
                    this.updateBatchProgress(batchResponse);
                } catch (error) {
                    // Si la respuesta se pierde después de aceptar el lote, consultar el mismo batchId evita reenviarlo.
                    batchResponse = await this.waitForImportBatch(batchId).catch(() => {
                        throw error;
                    });
                }

                if (batchResponse.status === 'processing') {
                    batchResponse = await this.waitForImportBatch(batchId);
                }
                else {
                    this.updateBatchProgress(batchResponse);
                }

                const itemsByGenerationCode = new Map(
                    itemsToProcess.map(item => [String(item.codigoGeneracion || '').trim(), item])
                );
                const reportedGenerationCodes = new Set();

                for (const result of batchResponse.results || []) {
                    const generationCode = String(result.generationCode || '').trim();
                    const item = itemsByGenerationCode.get(generationCode);
                    if (!item) continue;

                    reportedGenerationCodes.add(generationCode);
                    if (result.success) {
                        this.processed.push(item);
                    } else {
                        item.error = {
                            ...(item.error || {}),
                            message: result.message || 'No fue posible procesar este comprobante.',
                            isGenerationCodeLocked: result.code === 'GENERATION_CODE_LOCKED',
                        };
                        this.notProcessed.push(item);
                    }
                }

                for (const item of itemsToProcess) {
                    const generationCode = String(item.codigoGeneracion || '').trim();
                    if (!reportedGenerationCodes.has(generationCode)) {
                        item.error = {
                            ...(item.error || {}),
                            message: batchResponse.error || 'El lote no devolvió resultado para este comprobante.',
                        };
                        this.notProcessed.push(item);
                    }
                }

                this.loading = false;
                this.isProcessing = false;
                if(itemsToProcess.length === this.processed.length) {
                    this.showAlert("success", "Comprobantes de retencion", "Los Comprobantes de retencion importados fueron agragados correctamente.");
                }
                else if(itemsToProcess.length === this.notProcessed.length) {
                    this.showAlert("warning", "Comprobantes de retencion", "Los Comprobantes de retencion importados no pudieron procesarse debido a la existencia de errores.");
                }
                else if(itemsToProcess.length !== this.processed.length) {
                    this.showAlert("warning", "Comprobantes de retencion", "Algunos Comprobantes de retencion importados no pudieron procesarse debido a la existencia de errores.");
                }
            } 
            catch (error) {
                this.loading = false;
                this.isProcessing = false;
                this.processError = true;
                this.showAlert("danger", "Error", error.message || "Ocurrio un error en el procesamiento de la información.");
            }
        },
        switchEntryData(item) {
            if(!item) return;
            
            for (const element of this.dataFiles) {
                if(element.identificacion.numeroControl == item.numeroControl && element.identificacion.codigoGeneracion == item.codigoGeneracion) {
                    element.toEntry = !element.toEntry;
                }
            }
        },
        switchSelectAll() {
            for (const item of this.data) {
                item.toEntry = this.selectAll;
            }
            for (const item of this.dataFiles) {
                item.toEntry = this.selectAll;
            }
        },
        setCustomCSVPeriod(val){
            this.CustomCSVPeriodFlag = val
        },
        setCustomCSVPeriodYear(val){
            this.CustomCSVPeriodYear = val
        },
        setCustomCSVPeriodMonth(val){
            this.CustomCSVPeriodMonth = val
        },
        deleteFile(file) {
            this.data = this.data.filter((item) => item.numeroControl != file.numeroControl && item.codigoGeneracion != file.codigoGeneracion);
            this.dataFiles = this.dataFiles.filter((item) => item.identificacion.numeroControl != file.numeroControl && item.identificacion.codigoGeneracion != file.codigoGeneracion);
        },
        resetData() {
            this.dataLoaded = false;
            this.selectAll = false;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.errors = null;
            this.processError = false;
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
        },
        handleIndividualFiles(event) {
            //console.log('----here----', event);
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.endsWith('.json') || file.name.endsWith('.JSON'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...this.selectedFiles, ...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON seleccionados.');
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        closeAlert() {
            this.alert.show = false;
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
        },
        acceptAlert() {
            this.alert.show = false;
            if (this.alert.options == 'processData') {
                this.processData();
            }
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
            if (this.alert.options == 'structureValidation') {
                this.structureValidation();
            }
            if (this.alert.options == 'handleFilesUpload') {
                this.handleFilesUpload();
            }
        },
        showError(message) {
            this.showAlert("warning", "Advertencia", message);
        },
        hasSelloRecibido(item) {
            return Boolean(String(item?.selloRecibido || "").trim());
        },
        getSelloRowClass(item) {
            return this.hasSelloRecibido(item) ? "" : "sello-recibido-faltante";
        },
        sortDataByMissingSello() {
            this.data.sort((firstItem, secondItem) => {
                const firstMissing = this.hasSelloRecibido(firstItem) ? 0 : 1;
                const secondMissing = this.hasSelloRecibido(secondItem) ? 0 : 1;
                return secondMissing - firstMissing;
            });
        },
        isSelloReadOnly(item) {
            return Boolean(item?.selloRecibidoFromJson && !item.selloRecibidoEditing);
        },
        toggleSelloEditing(item) {
            this.$set(item, "selloRecibidoEditing", !item.selloRecibidoEditing);
        },
        formatMhDate(date) {
            if (!date) return "";
            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
            const parts = date.split("/");
            if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
            return date;
        },
        getDteConsultationUrl(item) {
            const identificacion = item?.dteJson?.identificacion || item?.identificacion || {};
            const codigoGeneracion = identificacion.codigoGeneracion;
            const fechaEmi = this.formatMhDate(identificacion.fecEmi);

            if (!codigoGeneracion || !fechaEmi) return "";

            const ambiente = identificacion.ambiente || "00";
            return `https://admin.factura.gob.sv/consultaPublica?ambiente=${encodeURIComponent(ambiente)}&codGen=${encodeURIComponent(codigoGeneracion)}&fechaEmi=${encodeURIComponent(fechaEmi)}`;
        },
        openDteConsultation(item) {
            const url = this.getDteConsultationUrl(item);
            if (!url) {
                this.showAlert("warning", "Advertencia", "No fue posible construir la consulta del DTE porque faltan datos de ambiente, código de generación o fecha de emisión.");
                return;
            }

            window.open(url, "_blank", "noopener,noreferrer");
        },
    },
    computed: {
        batchProgressPercent() {
            if (!this.batchProgress.total) return 0;
            return Math.min(100, Math.round((this.batchProgress.completed / this.batchProgress.total) * 100));
        },
        pendingBatchCount() {
            return Math.max(0, this.batchProgress.total - this.batchProgress.completed);
        },
    },
}
</script>

<style scoped>
.card-step {
    min-height: 400px; 
    width: 100%; 
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2rem;
}
.col-input-file {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 1rem;
}
.sello-recibido-editor {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 340px;
}
.sello-recibido-input {
    min-width: 260px;
}
.sello-recibido-edit-button {
    flex: 0 0 auto;
    text-transform: none !important;
}
.batch-progress-card {
    padding: 8px 16px 24px !important;
}
.batch-progress-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    color: #424242;
}
.batch-progress-percent {
    text-align: right;
    margin-top: 4px;
    color: #616161;
    font-size: 13px;
}
.batch-progress-counters {
    display: grid;
    grid-template-columns: repeat(4, minmax(120px, 1fr));
    gap: 12px;
    margin-top: 18px;
}
.batch-progress-counter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 14px;
    border-radius: 5px;
    border-left: 4px solid #9e9e9e;
    background: #f5f5f5;
}
.batch-progress-counter strong {
    font-size: 20px;
}
.batch-progress-success {
    border-left-color: #2e9d68;
    background: #edf8f1;
}
.batch-progress-pending {
    border-left-color: #3498db;
    background: #eef7fd;
}
.batch-progress-error {
    border-left-color: #e3191e;
    background: #fff0f0;
}
.batch-progress-neutral {
    border-left-color: #9e9e9e;
    background: #f5f5f5;
}
.batch-progress-note {
    margin: 12px 0 0;
    color: #757575;
    font-size: 13px;
}
@media (max-width: 700px) {
    .batch-progress-counters {
        grid-template-columns: repeat(2, minmax(120px, 1fr));
    }
}
.btn-import {
  background-color: #3498db !important;
  color: white;
  min-width: 250px !important;
  height: 40px !important;
}
.btnoption {
  background-color: #3498DB !important;
  color: white;
}
.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}
.btndisable {
    background-color: #41464c !important;
    color: white;
}
</style>

<style>
.mdi-file-excel::before {
    font-size: 32px !important;
}
.data-table .v-data-table__wrapper thead th {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.data-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.data-table .v-data-table__wrapper tbody tr.sello-recibido-faltante {
    background-color: #fff3cd !important;
}
.data-table .v-data-table__wrapper tbody tr.sello-recibido-faltante td {
    border-top: 1px solid #f0ad4e !important;
    border-bottom: 1px solid #f0ad4e !important;
}
.data-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.file-table .v-data-table__wrapper thead th {
    height: 5px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td.text-start {
    padding: 0px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.tabs-seg .v-slide-group__content {
    justify-content: space-between;
}
.check .v-input__control {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
}

</style>
